<template>
    <div>
        <bv-top></bv-top>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                :immediate-check="false"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
        >
            <van-card v-for="(item,index) in voteList" :key="index">
                <div class="title"  slot="title">
                    <div class="titleContent">{{item.projectName}}</div>
                </div>
                <div slot="desc">
                    <ul>
                        <li>项目预算：{{item.projectBudget}}（元）</li>
                        <li>个人分摊：{{item.viteApportion}}（元）</li>
                        <li>房屋坐落：{{item.houseStand}}</li>
                    </ul>
                </div>
                <div class="footer" slot="footer" @click="houseListInfo">
                    <div slot="tags" class="footerFont">查看详情</div>
                    <van-image width="10" height="10" :src="rightImg" />
                </div>
            </van-card>
        </van-list>
    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import {voteList} from '@/api/maintainFund/maintainFund'
    import '@/styles/maintainFund.scss'
    export default {
        name: "VoteList",
        data(){
            return{
                rightImg:require('@/assets/listRight.png'),
                voteList: [],
                //滑动底部加载状态
                loading: false,
                //数据是否全部加载完毕
                finished: false,
                error: false,
                //分页
                currentPage: 1,
                pageCount: 1,
                pageSize: 5,
            }
        },
        components:{
            BvTop:Top
        },
        mounted() {
            this.showLoading();
            let param = {
                page: this.currentPage,
                limit: this.pageSize
            };
            voteList(param).then(res => {
                this.voteList = res.data.list;
                this.pageCount = res.data.pages;
                // 数据全部加载完成
                if (this.currentPage == this.pageCount || this.pageCount == 0) {
                    this.finished = true;
                }
                this.$toast.clear();
            });
        },
        methods:{
            //全屏加载提示
            showLoading() {
                this.$toast.loading({
                    // 持续展示 toast
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                });
            },
            houseListInfo(){
                this.$router.push({path:'/maintainFund/voteListInfo',query:{label:'在线表决详细信息'}})
            },
            onLoad() {
                //滑动底部加载
                setTimeout(() => {
                    this.currentPage = this.currentPage + 1;
                    let param = {
                        page: this.currentPage,
                        limit: this.pageSize
                    };
                    voteList(param).then(res => {
                        //数据拼接
                        this.voteList = this.voteList.concat(res.data.list);
                        this.pageCount = res.data.pages;

                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.currentPage == this.pageCount) {
                            this.finished = true;
                        }
                    }).catch(() => {
                        this.error = true;
                    });
                }, 500);
            }
        }
    }
</script>

<style scoped></style>
